// extracted by mini-css-extract-plugin
export default {"caption":"field_caption__LvESs","cnt":"field_cnt__9eadx"};